export var BusinessDocumentType;
(function (BusinessDocumentType) {
    BusinessDocumentType["File"] = "FILE";
    BusinessDocumentType["Photo"] = "PHOTO";
    BusinessDocumentType["Text"] = "TEXT";
})(BusinessDocumentType || (BusinessDocumentType = {}));
//# sourceMappingURL=BusinessDocumentType.js.map